var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttentionOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00066 15.1666C8.8763 15.1677 9.74354 14.9958 10.5525 14.6607C11.3615 14.3256 12.0963 13.8339 12.7147 13.2139C13.3346 12.5956 13.8263 11.8608 14.1614 11.0518C14.4965 10.2428 14.6685 9.37557 14.6673 8.49992C14.6684 7.62428 14.4965 6.75705 14.1614 5.94807C13.8263 5.13908 13.3346 4.40429 12.7147 3.78592C12.0963 3.16593 11.3615 2.67426 10.5525 2.33915C9.74354 2.00405 8.8763 1.83212 8.00066 1.83326C7.12501 1.83214 6.25778 2.00407 5.4488 2.33918C4.63981 2.67428 3.90503 3.16595 3.28666 3.78592C2.66668 4.40429 2.17501 5.13908 1.83991 5.94807C1.50481 6.75705 1.33287 7.62428 1.33399 8.49992C1.33286 9.37557 1.50478 10.2428 1.83989 11.0518C2.17499 11.8608 2.66667 12.5956 3.28666 13.2139C3.90503 13.8339 4.63981 14.3256 5.4488 14.6607C6.25778 14.9958 7.12501 15.1677 8.00066 15.1666Z",
    fill: "#E57200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13C8.26522 13 8.51957 12.8946 8.70711 12.7071C8.89464 12.5196 9 12.2652 9 12C9 11.7348 8.89464 11.4804 8.70711 11.2929C8.51957 11.1054 8.26522 11 8 11C7.73478 11 7.48043 11.1054 7.29289 11.2929C7.10536 11.4804 7 11.7348 7 12C7 12.2652 7.10536 12.5196 7.29289 12.7071C7.48043 12.8946 7.73478 13 8 13Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5L8 9L8 5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5L8 9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionOrange);
export default __webpack_public_path__ + "static/media/attention-orange.52db5fab9b230a72c93d9cd000ddcce1.svg";
export { ForwardRef as ReactComponent };